import { render, staticRenderFns } from "./AuthorityGroupIframe.vue?vue&type=template&id=5f4d6f13&"
import script from "./AuthorityGroupIframe.vue?vue&type=script&lang=ts&"
export * from "./AuthorityGroupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports